<template>
  <GfrContainer>
    <section class="patch-notes-wrapper">
      <div class="patch-notes-list">
        <div class="patch-note-item" v-for="(article, idx) in articleList" :key="article.title">
          <div class="patch-note-item-anchor">
            <IconsClock class="text-[#FFBA00]" />
          </div>
          <div :class="[{ ['lg:!pb-0']: articleList?.length === idx + 1 }, 'patch-note-item-content']">
            <div class="patch-note-content-version">
              <div class="patch-note-content-date">{{ formatDate(article.date) }}</div>
              <div class="patch-note-content-title" v-html="formatTitle(article.title)"></div>
            </div>
            <div class="patch-note-content-text app-markdown-content" v-html="article.content_html"></div>
          </div>
        </div>
        <slot />
      </div>
    </section>
  </GfrContainer>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
interface ArticleItem {
  id: number
  title: string
  author: string
  abstract: string
  image: string
  date: number
  content: string
  content_html: string
  firstSeen: boolean
}

defineProps({
  articleList: {
    type: Array as unknown as PropType<ArticleItem[]>
  }
})

const formatDate = (date: number) => {
  return formatTime(date).substring(3).replace('/', ' / ')
}

const formatTitle = (title: string) => {
  return `${title.replace('{style}', '<span style="color: #FFBA00">').replace('{style}', '</span>')}`
}
</script>

<style lang="scss">
@import '@/assets/css/markdown-theme.scss';
</style>
<style lang="scss" scoped>
.patch-notes-wrapper {
  @apply min-h-[calc(100vh-var(--header-height)-12px)] w-full  px-0 pb-13 pt-5 mt-6;
  //  background
  @apply bg-[position:0_0] bg-repeat-y;
  //   横屏样式
  @apply max-lg:min-h-[calc(100vh-344px)] max-lg:mt-0 max-lg:pt-3 max-lg:pb-8;
}

.patch-notes-list {
  @apply relative;
  //  after
  @apply after:h-[calc(100%-52px)] after:w-[1px] after:content-[""];
  // after-position
  @apply after:absolute after:-top-5 ltr:after:left-2 rtl:after:right-2;
  // after-bg
  @apply after:bg-[#363A41];
  // font
  @apply font-gff-latin;
  //  mobile
  @apply max-lg:w-full;

  @apply max-lg:after:hidden;
}

.patch-note-item {
  @apply relative flex w-8xl;
  @apply max-lg:w-full;
}

.patch-note-item-anchor {
  @apply h-[30px] w-[18px];
  @apply flex items-center justify-center;
  // position
  @apply absolute ltr:left-0 rtl:right-0 top-0 z-[1];
  // mobile
  @apply max-lg:justify-start;
}

.patch-note-item-content {
  @apply flex-1 pb-8;
  @apply max-lg:w-full;
  @apply ltr:pl-[34px] rtl:pr-[34px] ltr:max-lg:pl-4.5 rtl:max-lg:pr-4.5;
  @apply max-lg:pb-6;
}

.patch-note-content-version {
  @apply flex  justify-start  items-start;
}

.patch-note-content-date {
  // font
  @apply pl-[5px] h-[30px] w-[82px] text-[14px]/[22px] font-normal text-[#fff] text-nowrap flex-grow-0 flex-shrink-0;
  @apply flex items-center justify-center;
  @apply bg-[url('@/assets/images/date-bg.png')];
  @apply max-lg:text-[var(--theme-white)];
  // mobile
  @apply max-lg:text-[12px]/[18px] max-lg:w-[73px] max-lg:h-[26px];
}

.patch-note-content-title {
  @apply pl-4 text-[20px]/[30px] text-[#FFBA00] font-medium;
  @apply max-lg:text-[16px]/[24px];
}

.patch-note-content-text {
  @apply w-full text-[14px]/[22px] pt-2 my-0;
  @apply max-lg:pt-2;

  & > :nth-last-child(1) {
    margin-bottom: 0;
  }

  &:deep(h1) {
    // @apply text-[38px]/[46px] font-bold text-white mt-10;
    &:nth-child(1) {
      @apply mt-0;
    }
  }
  &:deep(h2) {
    // @apply text-[38px]/[46px] font-bold text-white mt-10;
    &:nth-child(1) {
      @apply mt-0;
    }
  }
  &:deep(h3) {
    // @apply text-[38px]/[46px] font-bold text-white mt-10;
    &:nth-child(1) {
      @apply mt-0;
    }
  }
  &:deep(h4) {
    // @apply text-[38px]/[46px] font-bold text-white mt-10;
    &:nth-child(1) {
      @apply mt-0;
    }
  }

  // &:deep(h2) {
  //   @apply text-[30px]/[38px] font-medium text-white mt-6;
  // }

  // &:deep(h3) {
  //   @apply text-[24px]/[32px] font-medium text-white  mt-4;
  // }

  // &:deep(h4) {
  //   @apply text-[20px]/[28px] font-medium text-white mt-4;
  // }

  // &:deep(h5) {
  //   @apply text-[16px]/[24px] font-medium text-white;
  // }

  // &:deep(p) {
  //   @apply my-4 text-[14px]/[22px] font-normal text-[#C8CCD3];
  // }

  // &:deep(img) {
  //   @apply h-auto max-w-full object-contain;
  // }

  // &:deep(pre code) {
  //   @apply my-2 block w-full whitespace-pre bg-[#323232] p-6 text-[.9rem]/[1.5] text-[#A6ACCD];
  //   // border
  //   @apply rounded-[10px];
  //   // transition
  //   @apply transition-colors delay-500;

  //   span {
  //     @apply text-[#FFBA00];
  //   }
  // }

  // &:deep(code) {
  //   @apply m-0 overflow-auto rounded-[4px] bg-[#5c5f6d] px-2 py-1 text-[0.85rem];
  //   //  font-family
  //   @apply font-gff-latin;
  // }

  // &:deep(a) {
  //   @apply underline;
  // }

  // &:deep(ol li) {
  //   @apply list-decimal;
  // }

  // &:deep(ul li) {
  //   @apply list-disc;
  // }

  // &:deep(ol),
  // &:deep(ul) {
  //   @apply mb-2 mt-1 ml-1 pl-4 leading-[22px];
  // }

  // /* Table */
  // &:deep(table) {
  //   border-collapse: collapse;
  //   width: 100%;
  //   border: 1px solid #363a41;
  //   margin-bottom: 20px;
  //   @apply text-[14px]/[22px];
  // }

  // //&:deep(table thead tr) {
  // //background-color: var(--table-thead-color);
  // //}

  // &:deep(table tr th) {
  //   font-weight: 400;
  //   border-left: 1px solid #363a41;
  //   border-right: 1px solid #363a41;
  //   text-align: left;
  //   margin: 0;
  //   padding: 8px;
  //   height: 38px;
  //   background-color: #3b3b3b;
  //   color: #fff;
  // }

  // &:deep(table tbody tr) {
  //   border-top: 1px solid #363a41;
  //   margin: 0;
  //   padding: 0;
  //   @apply text-[#d1d1d1];
  // }

  // //table tbody tr:nth-child(2n) {
  // //background-color: var(--table-bg-darker-color);
  // //}

  // //table tbody tr:nth-child(2n + 1) {
  // //background-color: var(--table-bg-color);
  // //}

  // &:deep(table tr td) {
  //   border-left: 1px solid #363a41;
  //   border-right: 1px solid #363a41;
  //   text-align: left;
  //   margin: 0;
  //   height: 40px;
  //   padding: 6px 10px;
  // }

  // &:deep(table tr th:first-child, table tr td:first-child) {
  //   border-left-width: 0;
  // }

  // &:deep(table tr th:last-child, table tr td:last-child) {
  //   border-right-width: 0;
  // }

  // //&:deep(table) {
  // //  text-indent: 0;
  // //  border-color: inherit;
  // //  border-collapse: collapse;
  // //  width: 100%;
  // //}
  // //&:deep(table tr th) {
  // //  color: #fff;
  // //  font-size: 16px;
  // //  min-height: 40px;
  // //  padding: 6px 10px;
  // //}
  // //&:deep(table tr td) {
  // //  color: #c8ccd3;
  // //  min-height: 40px;
  // //  padding: 6px 10px;
  // //}
  // &:deep(blockquote) {
  //   position: relative;
  //   padding: 10px 20px;
  //   background-color: #363a41;
  // }

  // &:deep(blockquote):before {
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 2px;
  //   height: 100%;
  //   background-color: #ffba00;
  // }

  // &:deep(video) {
  //   width: 100%;
  //   margin: 16px auto;
  // }

  // &:deep(iframe) {
  //   width: 700px;
  //   height: 394px;
  //   display: block;
  //   margin: 16px 0;
  //   position: relative;
  // }

  // &:deep(hr) {
  //   width: 100%;
  //   border-top: 1px solid #2b2d32;
  // }
}

@media not all and (min-width: 1024px) {
  .patch-note-content-text {
    // &:deep(h1) {
    //   @apply text-[24px]/[36px] font-medium text-white;
    // }

    // &:deep(h2) {
    //   @apply text-[22px]/[32px] font-medium text-white;
    // }

    // &:deep(h3) {
    //   @apply text-[18px]/[26px] font-medium text-white;
    // }

    // &:deep(h4) {
    //   @apply text-[16px]/[24px] font-medium text-white;
    // }

    // &:deep(h5) {
    //   @apply text-[14px]/[20px] font-medium text-white;
    // }

    // &:deep(p) {
    //   @apply text-[12px]/[18px] text-[#d1d1d1] font-regular;
    // }

    // &:deep(pre code) {
    //   display: block;
    //   padding: 24px;
    //   width: 100%;
    //   line-height: 1.5;
    //   font-size: 0.9em;
    //   color: #a6accd;
    //   transition: color 0.5s;
    //   background-color: #323232;
    //   border-radius: 10px;
    //   margin: 20px 0;
    //   white-space: pre;

    //   span {
    //     color: #ffba00;
    //   }
    // }

    // &:deep(code) {
    //   font-size: 24px;
    // }

    &:deep(iframe) {
      width: 100%;
      height: auto;
    }

    // &:deep(ol li) {
    //   @apply list-decimal text-[12px]/[18px] text-[#d1d1d1];
    // }

    // &:deep(ul li) {
    //   @apply list-disc  text-[12px]/[18px] text-[#d1d1d1];
    // }
  }
}
</style>
